<template>
    <ul class="growth-items pl-0">
        <li class="display-flex" v-for="(list,index) in TaskList" :key="index">
            <div class="g-items-icon pink-normal">+{{list.Score}}</div>
            <div class="display-flex g-item-info blue-title">
                <v-tooltip bottom v-if="list.EnDescription" content-class="commons-tooltip">
                    <div slot="activator" class="cursor-pointer g-item-desc">{{list.Name}}</div>
                    <span v-html="list.EnDescription"></span>
                </v-tooltip>
                <div v-else>{{list.Name}}</div>
                <!-- 领取积分 -->
                <v-btn v-if="list.Status === 2 && list.ReceiveStatus === 0" class="text-none height24 red-button receive-btn" @click="toReceivePoint($event,list.TaskCode)">
                    Receive
                    <span class="points">+{{list.Score}}</span>
                </v-btn> 
                <!-- 前往执行任务 -->
                <v-btn 
                    v-if="(list.Status === 1 || list.Status === 0)&& list.EventType !== 0" 
                    class="text-none height24 blue-button blue-border-button" 
                    :style="{'border-color':list.TaskCode===10004?(isPassedTL&&!isNeedToImprovePersonalInformation&&!awaitApproval)?'#3E67FB':'#e0e0e0':''}"
                    @click="goToImplement(list.TaskCode, list.Url)" 
                    :disabled="list.TaskCode===10004?(isPassedTL&&!isNeedToImprovePersonalInformation&&!awaitApproval)?false:true:false"
                    >
                    Proceed
                </v-btn> 
                <!-- 领取完成 -->
                <v-btn v-if="list.ReceiveStatus === 1 && list.Status == 2" class="text-none height24 cancel-button" disabled>Completed</v-btn> 
                <!-- 待完成 -->
                <v-btn v-if="(list.Status === 1 || list.Status === 0) && list.EventType === 0" class="text-none height24 blue-border-button pending">Pending</v-btn> 

            </div>
        </li>
    </ul>
</template>
<script>
import { receivePoint, growthSystemDoTask, getCourseLearning,medalLog } from '@/api/dashboard.js'
import store from '@/store'

export default {
    props:['TaskList'],
    data: () => ({
        
    }),
    computed:{
        isInternationalOrCustom(){
            return this.$store.state.user.isInternationalOrCustom
        },
        isPassedTL(){
            return this.$store.state.user.isPassedTL
        },
        isNeedToImprovePersonalInformation(){
            return this.$store.state.user.isNeedToImprovePersonalInformation
        },
        awaitApproval(){
            return this.$store.state.user.awaitApproval
        }
    },
    methods:{
        toReceivePoint (e,id) {


            receivePoint(id).then(res => {
                if(res.Code > 0){
                    //成功,todo分数动态效果
                    if(e.target.nodeName=='DIV'){
                        e.target.children[0].classList.add("add-points")
                    }else{
                        e.target.classList.add("add-points")
                    }
                    setTimeout(()=>{
                        // 分数动态效果完成后拉取
                        this.$store.dispatch('GetTutorHomeTask') //获取成长体系相关数据
                        this.$store.dispatch('GetGradeHonorDetail')//等级勋章数据
                        //this.$store.dispatch('GetMedalDetail')//荣誉勋章数据
                        // 移除动态效果的类/日常任务可重复点击领取积分
                        if(e.target.nodeName=='DIV'){
                            e.target.children[0].classList.remove("add-points")
                        }else{
                            e.target.classList.remove("add-points")
                        }
                    },2000)
                    // 升级下一等级
                    if(res.Up>0){
                        this.$store.dispatch('upGrade',true)
                    }
                }else{
                    this.$root.$alertTips(res.Msg, '',{ icon: { default:true } });
                }
            })
        },
        goToImplement(code, url){
            medalLog(code,2)

            growthSystemDoTask(code).then(res => {
            })
            if(code===30001){
                getCourseLearning().then(res=>{
                    if(res&&res.IsFirstClick) this.$emit('customFunF')
                    else this.$router.push({ path: '/trainingCenter/mySubscription' })
                })
            }else if(code===30007){
                this.$store.dispatch('openSpecialAchiMedals',true)
            }else if(code===10004){
                if(this.isInternationalOrCustom==1) this.$router.push({ path: '/signContractCustom' })
                else this.$router.push({ path: '/signContract' })
            }
            else{
                window.location.href = url
            }
        }
    }
}
</script>
<style lang="scss" scoped>
  @import "./growthSystem";
</style>